import { render, staticRenderFns } from "./Finddetails.vue?vue&type=template&id=5a2cd024&scoped=true"
import script from "./Finddetails.vue?vue&type=script&lang=js"
export * from "./Finddetails.vue?vue&type=script&lang=js"
import style0 from "./Finddetails.vue?vue&type=style&index=0&id=5a2cd024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2cd024",
  null
  
)

export default component.exports